// Two-button toggle shared by PredictionAnalysisPanel and MonitoringAnalysisPanel:
// switches LayerChatPanel between plain datatalk ("monitoring"/"prediction", the
// `dataMode` prop) and RAG guideline chat ("leitlinien").
type ChatMode = "monitoring" | "prediction" | "leitlinien"

type Props = {
    mode: ChatMode
    onModeChange: (mode: ChatMode) => void
    dataMode: "monitoring" | "prediction"
    dataModeLabel?: string
}

export default function AnalyseModeToggle({ mode, onModeChange, dataMode, dataModeLabel = "nur Daten" }: Props) {
    return (
        <div className="flex gap-2">
            <button
                type="button"
                onClick={() => onModeChange(dataMode)}
                className={
                    mode !== "leitlinien"
                        ? "bg-teal-500 text-white rounded-full px-3 py-1 text-xs font-semibold"
                        : "bg-white border border-gray-300 text-gray-600 rounded-full px-3 py-1 text-xs hover:border-teal-400"
                }
            >
                {dataModeLabel}
            </button>
            <button
                type="button"
                onClick={() => onModeChange("leitlinien")}
                className={
                    mode === "leitlinien"
                        ? "bg-blue-500 text-white rounded-full px-3 py-1 text-xs font-semibold"
                        : "bg-white border border-gray-300 text-gray-600 rounded-full px-3 py-1 text-xs hover:border-blue-400"
                }
            >
                mit Leitlinien
            </button>
        </div>
    )
}
